import { useQuery } from '@tanstack/react-query';
import { supabase } from '../services/supabase';

export interface ImageGroup {
  title?: string;
  images?: string[];
}

export interface Declaration {
  id: string;
  title: string;
  description?: string;
  date?: string;
  featured?: boolean;
  image_url?: string;
  additional_images?: string[];
  image_groups?: ImageGroup[];
}

export const useDeclarations = () => {
  return useQuery<Declaration[]>({
    queryKey: ['declarations'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('confessions')
        .select('id, title, description, date, featured, image_url, additional_images, image_groups')
        .order('featured', { ascending: false })
        .order('date', { ascending: false })
        .limit(200);
      if (error) throw error;
      return data as Declaration[];
    },
    staleTime: 5 * 60_000,
  });
};
